import {PaginationNumEnum} from 'enums';
import {IGoogleSite} from 'models/resources/google-sites';

export const calculatePaginationResult = (list: IGoogleSite[], currentPage: number, perPage: number): IGoogleSite[] =>
  list.slice((currentPage - PaginationNumEnum.ONE) * perPage, currentPage * perPage);
